import { useRequestDocuments } from '@/models/request';

type Documents = ReturnType<typeof useRequestDocuments>['data'];

export type Document = NonNullable<Documents>[number];

type DocumentType = Document['type'];
type DocumentDuplicateCriteria = keyof Document;

export const removeDuplicatedDocuments = ({
  documents,
  duplicationCriterias,
}: {
  documents: Document[];
  duplicationCriterias: { [key in DocumentType]?: DocumentDuplicateCriteria[] };
}) =>
  documents.reduce((acc, document) => {
    const duplicateCriterias = duplicationCriterias[document.type];

    if (!duplicateCriterias || !duplicateCriterias.length) {
      acc.push(document);

      return acc;
    }

    const documentDuplicateIndex = acc.findIndex((doc) =>
      duplicateCriterias.every((criteria) => doc[criteria] === document[criteria])
    );

    if (documentDuplicateIndex === -1) {
      acc.push(document);

      return acc;
    }

    if (
      documentDuplicateIndex &&
      documentAIsOlderThanDocumentB(acc[documentDuplicateIndex], document)
    ) {
      acc[documentDuplicateIndex] = document;
    }

    return acc;
  }, [] as Array<Document>);

const documentAIsOlderThanDocumentB = (documentA: Document, documentB: Document) => {
  return new Date(documentA.createdAt).getTime() < new Date(documentB.createdAt).getTime();
};
